import React from 'react';
import TopicNameWithIcon from './TopicNameWithIcon';
import type { PillSize } from '../components/Pill';
import Pill from '../components/Pill';
import Tooltip from '../components/Tooltip';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import topicPath from '../utils/url/topicPath';

const TOPIC_PILL_FRAGMENT = gql(`
  fragment TopicPill_topic on Topic {
    ...topicPath_topic
    ...TopicNameWithIcon_topic
  }
`);

interface TopicPillProps
  extends Pick<React.ComponentProps<typeof Pill>, 'icon'> {
  onRemove?: React.MouseEventHandler;
  topic: DocumentType<typeof TOPIC_PILL_FRAGMENT>;
  highlighted?: boolean;
  name?: React.ReactNode;
  size?: PillSize;
  tooltip?: string;
}

const TopicPill = ({
  onRemove,
  topic,
  icon,
  tooltip,
  highlighted,
  name,
  size,
}: TopicPillProps) => {
  const content = (
    <Pill
      type="topic"
      icon={icon}
      to={onRemove ? undefined : topicPath(topic)}
      onClick={onRemove}
      size={size}
    >
      <TopicNameWithIcon topic={topic} highlighted={highlighted} name={name} />
    </Pill>
  );

  if (tooltip) {
    return <Tooltip content={tooltip}>{content}</Tooltip>;
  }
  return content;
};

export default TopicPill;
